<template>
  <router-view />
</template>

<script>
export default {
}
</script>

<style scoped>
h1 {
  color: #2c3e50
}
</style>
